import { Modal } from 'react-bootstrap';
import { showDialog } from 'dialogs';
import EditUser from '../editUser';

/**
 * Open the user create / edit dialog. `EditUser` is the form body; this wraps it
 * in the modal shell (as the list page did) and mounts it via showDialog.
 * `EditUser` persists and calls its `closeModal` on completion.
 */
export const showEditUser = (userId: number | null): void => {
  showDialog((close) => (
    <Modal show onHide={close} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{userId ? 'Edit User' : 'New User'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EditUser userId={userId} closeModal={close} />
      </Modal.Body>
    </Modal>
  ));
};
